import { render, staticRenderFns } from "./RadiosInput.vue?vue&type=template&id=2a996310&"
import script from "./RadiosInput.vue?vue&type=script&lang=js&"
export * from "./RadiosInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports